import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FailoverWarningComponent } from './failover-warning.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    FailoverWarningComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  exports: [FailoverWarningComponent]
})
export class FailoverWarningModule { }
